<template>
  <div class="RegistrazioneModulo col-24">
    <h1>{{$t('register.title')}}</h1>

    <div class="row row-custom">
      <el-collapse v-model="activeName" @change="changeTab" class="no-padding col-12" style="padding-right: 10px !important;">
        <el-collapse-item name="a">
          <template slot="title">
            <div @click="cambio('a')">
              <div class="icon" :class="{'is-correct' : validateStep1}">
                <span v-if="!validateStep1">1</span>
                <icon v-else name="riv-tick" scale="1"></icon>
              </div>
              <span class="des">{{$t('register.form1.title')}}</span>
            </div>
          </template>
          <div class="">
            <el-form :model="step1Form" :rules="rulesStep1" ref="step1Form" class="" :show-message=false>
              <el-form-item prop="codiceForn" :class="{'is-error' : isErrorLogin}">
                <el-input v-model="step1Form.codiceForn" v-bind:placeholder="$t('register.form1.codiFor')"
                          @change="clearError(1)"></el-input>
              </el-form-item>
              <el-form-item prop="codicePIN" :class="{'is-error' : isErrorLogin}">
                <el-input v-model="step1Form.codicePIN" v-bind:placeholder="$t('register.form1.codiPin')"
                          @change="clearError(1)"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button @click="validateForm('step1Form',1)">{{$t('register.btn.next')}}</el-button>
              </el-form-item>

            </el-form>
          </div>
        </el-collapse-item>
        <el-collapse-item title="2" name="b">
          <template slot="title">
            <div @click="cambio('b')">
              <div class="icon" :class="{'is-correct' : validateStep2}">
                <span v-if="!validateStep2">2</span>
                <icon v-else name="riv-tick" scale="1"></icon>
              </div>
              <span class="des">{{$t('register.form2.title')}}</span>
            </div>
          </template>
          <div>
            <el-checkbox-group v-model="appsRichieste">
              <el-checkbox v-for="app in appsRichiedibili" :label="app.codiApp" :key="app.codiApp">{{ app.descApp }}</el-checkbox>
            </el-checkbox-group>
            <el-button @click="validateServices()" :disabled="(appsRichieste.length === 0)">{{$t('register.btn.next')}}</el-button>
          </div>
        </el-collapse-item>
        <el-collapse-item title="Feedback" name="c">
          <template slot="title">
            <div @click="cambio('c')">
              <div class="icon" :class="{'is-correct' : validateStep3}">
                <span v-if="!validateStep3">3</span>
                <icon v-else name="riv-tick" scale="1"></icon>
              </div>
              <span class="des">{{$t('register.form3.title')}}</span>
            </div>
          </template>
          <div class="">
            <el-form :model="step3Form" :rules="rulesStep3" ref="step3Form" class="" :show-message=false>
              <el-form-item prop="nome" :class="{'is-error' : isErrorLogin}">
                <el-input v-model="step3Form.nome" v-bind:placeholder="$t('register.form3.name')"
                          @change="clearError(3)"></el-input>
              </el-form-item>
              <el-form-item prop="cognome" :class="{'is-error' : isErrorLogin}">
                <el-input v-model="step3Form.cognome" v-bind:placeholder="$t('register.form3.surname')"
                          @change="clearError(3)"></el-input>
              </el-form-item>
              <el-form-item prop="mail" :class="{'is-error' : isErrorLogin}">
                <el-input v-model="step3Form.mail" v-bind:placeholder="$t('register.form3.mail')"
                          @change="clearError(3)"></el-input>
              </el-form-item>
              <el-form-item prop="tel" :class="{'is-error' : isErrorLogin}">
                <el-input v-model="step3Form.tel" v-bind:placeholder="$t('register.form3.tel')"
                          @change="clearError(3)"></el-input>
              </el-form-item>
              <el-form-item prop="birthday">
                <el-date-picker
                  v-model="step3Form.birthday"
                  v-bind:placeholder="$t('register.form3.birthday')"
                  type="date"
                  @change="clearError(3)"
                  format="dd/MM/yyyy"
                  value-format="dd/MM/yyyy"></el-date-picker>
              </el-form-item>
              <el-form-item prop="reparto">
                <el-input v-model="step3Form.reparto" v-bind:placeholder="$t('register.form3.department')"
                          @change="clearError(3)"></el-input>
              </el-form-item>
              <el-form-item prop="ruolo">
                <el-input v-model="step3Form.ruolo" v-bind:placeholder="$t('register.form3.role')"
                          @change="clearError(3)"></el-input>
              </el-form-item>
              <el-form-item prop="cell">
                <el-input v-model="step3Form.cell" v-bind:placeholder="$t('register.form3.mobile')"
                          @change="clearError(3)"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button @click="validateForm('step3Form',3)">{{$t('register.btn.next')}}</el-button>
              </el-form-item>

            </el-form>
          </div>
        </el-collapse-item>
        <el-collapse-item title="4" name="d" id="form4">
          <template slot="title">
            <div @click="cambio('d')">
              <div class="icon">
                <span>4</span>
              </div>
              <span class="des">{{$t('register.form4.title')}}</span>
            </div>
          </template>
          <div class="">
            <el-form :model="step4Form" :rules="rulesStep4" ref="step4Form" class="" :show-message="true">
              <el-form-item prop="user" :class="{'is-error' : isErrorLogin}" class="form-username">
                <div class="row row-custom">
                  <el-input v-model="step4Form.user" v-bind:placeholder="$t('register.form4.user')" :maxlength="20" autocomplete="new-username"
                            @change="clearError(4)" @focus="clearValidation('user')" class="col-21 no-padding"></el-input>
                  <div class="col-3 no-padding help">
                    <el-tooltip class="item" effect="dark" :content="($t('register.form4.userTooltip'))" placement="top">
                      <icon name="riv-help" class="pointer" scale="1"></icon>
                    </el-tooltip>
                  </div>
                </div>
              </el-form-item>
              <el-form-item prop="password" :class="{'is-error' : isErrorLogin}" class="form-password">
                <div class="row row-custom">
                  <el-input v-model="step4Form.password" v-bind:placeholder="$t('register.form4.password')" type="password" autocomplete="new-password"
                            @change="clearError(4)" class="col-21 no-padding"  @focus="clearValidation('password')"></el-input>
                  <div class="col-3 no-padding help">
                    <el-tooltip class="item" effect="dark" :content="($t('register.form4.pswTooltip'))" placement="top">
                      <icon name="riv-help" class="pointer" scale="1"></icon>
                    </el-tooltip>
                  </div>
                </div>
              </el-form-item>
              <el-form-item prop="passwordRep">
                <div class="row row-custom">
                  <el-input v-model="step4Form.passwordRep" v-bind:placeholder="$t('register.form4.passwordRepeat')"
                            type="password" class="col-21 no-padding"
                            @change="clearError(4)"></el-input>
                </div>
              </el-form-item>
              <el-form-item prop="domanda" :class="{'is-error' : isErrorLogin}">
                <div class="row row-custom">
                  <el-select v-model="step4Form.domanda" @change="clearError(4)" class="col-21 no-padding"
                             v-bind:placeholder="$t('register.form4.rqsQstn')">
                    <el-option
                      v-for="item in secretQuestions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
              </el-form-item>
              <el-form-item prop="risposta" :class="{'is-error' : isErrorLogin}">
                <div class="row row-custom">
                  <el-input v-model="step4Form.risposta" v-bind:placeholder="$t('register.form4.ansQstn')"
                            @change="clearError(4)" class="col-21 no-padding"></el-input>
                </div>
              </el-form-item>
              <el-form-item prop="checkPrivacy" :class="{'is-error' : isErrorLogin}" class="info" v-if="(step1Form.codicePIN.substr(0, 2) !== 'ES')">
                <span class="displayBlock">{{$t('register.form4.infoPersData')}}</span>
                <a href="https://www.rivaacciaio.com/TMS/items/1132/allegati/1/RivaAcciaio_InformativaPrivacy_area_riservata_Fornitori.pdf" target="_blank" class="displayBlock" v-if="(step1Form.codicePIN.substr(0, 2) === 'IT')">
                  <img src="../../../static/img/pdf.png">
                  <span>{{$t('register.form4.docPersData') + ' Riva Acciaio'}}</span>
                </a>
                <a href="https://www.rivagroup.com/TMS/items/1580/allegati/1/RFE_Informativa_Privacy_area_riservata_Fornitori.pdf" target="_blank" class="displayBlock" v-if="(step1Form.codicePIN.substr(0, 2) === 'IT')">
                  <img src="../../../static/img/pdf.png">
                  <span>{{$t('register.form4.docPersData') + ' Riva Forni Elettrici'}}</span>
                </a>
                <a href="https://www.rivaacier.com/items/1296/allegati/1/RivaAcier_ProtectionDonnees_WEB_FR.pdf" target="_blank" class="displayBlock" v-if="(step1Form.codicePIN.substr(0, 2) === 'FR')">
                  <img src="../../../static/img/pdf.png">
                  <span>{{$t('register.form4.docPersData')}}</span>
                </a>
                <a href="https://www.thy-marcinelle.com/politique-de-protection-des-donnees/" target="_blank" class="displayBlock" v-if="(step1Form.codicePIN.substr(0, 2) === 'BE')">
                  <img src="../../../static/img/pdf.png">
                  <span>{{$t('register.form4.docPersData')}}</span>
                </a>
                <a href="https://www.rivastahl.com/items/736/allegati/1/Rivastahl_Datenschutzerklarung_DE.pdf" target="_blank" class="displayBlock" v-if="(step1Form.codicePIN.substr(0, 2) === 'DE')">
                  <img src="../../../static/img/pdf.png">
                  <span>{{$t('register.form4.docPersData')}}</span>
                </a>
                <el-checkbox v-model="step4Form.checkPrivacy">{{$t('register.form4.viewed')}}</el-checkbox>
              </el-form-item>
              <div class="box-riempimento" v-else></div>
              <vue-recaptcha @verify="markRecaptchaAsVerified" sitekey="6LcG-mAUAAAAACmmUnjiyUGWkBBQ5qgRpjalZRev">
              </vue-recaptcha>
              <el-form-item>
                <el-button @click="submitForm('step4Form')">{{$t('register.btn.register')}}</el-button>
              </el-form-item>

            </el-form>
          </div>
        </el-collapse-item>
      </el-collapse>
      <div class="gdpr-spagna col-12 no-padding" v-if="(step1Form.codicePIN.substr(0, 2) === 'ES' && currentActiveName ==='d')">
        <div class="contenitore-gdpr">
          <div class="titolo col-24">
            {{ $t('register.gdpr.titolo') }}
          </div>
          <div class="box">
            <div class="subtitolo col-24">
              {{ $t('register.gdpr.respTrattTitolo') }}
            </div>
            <div class="testo col-24">
              {{ $t('register.gdpr.respTrattTesto') }}
            </div>
            <div class="subtitolo col-24">
              {{ $t('register.gdpr.finTrattTitolo') }}
            </div>
            <div class="testo col-24">
              {{ $t('register.gdpr.finTrattTesto') }}
            </div>
            <div class="subtitolo col-24">
              {{ $t('register.gdpr.legTrattTitolo') }}
            </div>
            <div class="testo col-24">
              {{ $t('register.gdpr.legTrattTesto') }}
            </div>
            <div class="subtitolo col-24">
              {{ $t('register.gdpr.destTitolo') }}
            </div>
            <div class="testo col-24">
              {{ $t('register.gdpr.destTesto') }}
            </div>
            <div class="subtitolo col-24">
              {{ $t('register.gdpr.doveriTitolo') }}
            </div>
            <div class="testo col-24">
              {{ $t('register.gdpr.doveriTesto') }}
            </div>
            <div class="subtitolo col-24">
              {{ $t('register.gdpr.infoAddTitolo') }}
            </div>
            <div class="testo col-24">
              {{ $t('register.gdpr.infoAddTesto') }} <a href="https://www.siderurgicasevillana.com/items/735/allegati/1/PoliticaDePrivacidad_SiderurgicaSevillana.pdf" target="_blank"> {{ $t('register.gdpr.cliccaQui') }} </a>
            </div>
            <div class="check-privacy col-24 no-padding">
              <el-checkbox v-model="step4Form.checkPrivacy">
                <div class="text-checkbox">{{ $t('register.gdpr.hoLetto') }}</div>
              </el-checkbox>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import VueRecaptcha from 'vue-recaptcha'

  export default {
    name: 'Register',
    props: ['language'],
    watch: {
      language: function(newVal, oldVal) {
        this.getSecretQuestions()
      }
    },
    components: {'vue-recaptcha': VueRecaptcha},
    data () {
      let userValidator = (rule, value, callback) => {
        let regex = new RegExp('^[A-Za-z][A-Za-z0-9_@#.-]{5,15}$')
        if (regex.test(value)) {
          callback()
        } else {
          callback(new Error('!'))
        }
      }
      let pswValidator = (rule, value, callback) => {
        let regex = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[@$!%*?&#._-])[a-zA-Z0-9@$!%*?&#._-]{12,30}$')
        if (regex.test(value)) {
          callback()
        } else {
          callback(new Error('!'))
        }
      }
      return {
        appsRichiedibili: [],
        appsRichieste: [],
        activeName: ['a'],
        currentActiveName: 'a',
        validateStep1: false,
        validateStep2: false,
        validateStep3: false,
        validateStep4: false,
        step1Form: {
          codiceForn: '',
          codicePIN: ''
        },
        step3Form: {
          nome: '',
          cognome: '',
          birthday: '',
          reparto: '',
          ruolo: '',
          mail: '',
          tel: '',
          cell: ''
        },
        step4Form: {
          user: '',
          password: '',
          passwordRep: '',
          domanda: '',
          risposta: '',
          checkPrivacy: '',
          recaptchaToken: ''
        },
        rulesStep1: {
          codiceForn: [
            {required: true, trigger: 'blur'}
          ],
          codicePIN: [
            {required: true, trigger: 'blur'}
          ]
        },
        rulesStep3: {
          nome: [
            {required: true, trigger: 'blur'}
          ],
          cognome: [
            {required: true, trigger: 'blur'}
          ],
          mail: [
            {required: true, trigger: 'blur'}
          ],
          tel: [
            {required: true, trigger: 'blur'}
          ]
        },
        rulesStep4: {
          user: [
            {required: true, validator: userValidator, trigger: 'blur'}
          ],
          password: [
            {required: true, validator: pswValidator, trigger: 'blur'}
          ],
          passwordRep: [
            {required: true, trigger: 'blur'}
          ],
          domanda: [
            {required: true, trigger: 'change'}
          ],
          risposta: [
            {required: true, trigger: 'blur'}
          ],
          checkPrivacy: [
            {required: true, trigger: 'change'}
          ]
        },
        isErrorLogin: false,
        secretQuestions: {}
      }
    },
    i18n: {
      messages: {
        it_IT: {
          register: {
            gdpr: {
              titolo: 'Información Básica sobre Protección de Datos',
              respTrattTitolo: 'Responsable del tratamiento',
              respTrattTesto: 'SIDERÚRGICA SEVILLANA S.A',
              finTrattTitolo: 'Finalidad del tratamiento',
              finTrattTesto: 'Realizar la gestión de la relación comercial entre las partes y la gestión fiscal y administrativa de nuestros proveedores.',
              legTrattTitolo: 'Legitimación del tratamiento',
              legTrattTesto: 'Relación contractual entre las partes.',
              destTitolo: 'Destinatarios',
              destTesto: 'Sus datos podrán comunicarse al resto de empresas del GRUPO RIVA para gestión empresarial que puede conllevar transferencia internacional de datos siempre en territorio de la UE.',
              doveriTitolo: 'Derechos',
              doveriTesto: 'Tiene derecho a acceder, rectificar y suprimir los datos, así como otros derechos, como se explica en la información adicional.',
              infoAddTitolo: 'Información adicional',
              infoAddTesto: 'Puede consultar la información adicional y detallada sobre Protección de Datos haciendo',
              cliccaQui: 'click aquí.',
              hoLetto: 'He leído y acepto las condiciones detalladas en la Información básica sobre protección de datos.'
            },
            title: 'Registrazione',
            form1: {
              title: 'Dati Attivazione',
              codiFor: 'Codice Fornitore *',
              codiPin: 'Codice PIN *'
            },
            form2: {
              title: 'Servizi Richiesti'
            },
            form3: {
              title: 'Dati Personali',
              name: 'Nome *',
              mail: 'e-Mail *',
              tel: 'Telefono Ufficio *',
              surname: 'Cognome *',
              birthday: 'Data di Nascita',
              department: 'Reparto',
              role: 'Ruolo',
              mobile: 'Telefono Cellulare'
            },
            form4: {
              title: 'Sicurezza',
              user: 'Utente *',
              password: 'Password *',
              passwordRepeat: 'Ripeti Password *',
              rqsQstn: 'Domanda Segreta *',
              ansQstn: 'Risposta Segreta *',
              infoPersData: 'Informativa sul Trattamento dei dati Personali',
              docPersData: 'Informativa privacy',
              viewed: 'Ho preso visione',
              userTooltip: 'Il nome utente deve cominciare con una lettera ed essere lungo da 6 a 16 caratteri alfanumerici (sono compresi anche # - _ @)',
              pswTooltip: 'La password deve essere lunga da 12 a 30 caratteri e deve contenere almeno una lettera maiuscola, una lettera minuscola, un numero e un carattere speciale tra @ $ ! % * ? & # . _ -'
            },
            btn: {
              next: 'Avanti',
              register: 'Registrati'
            },
            msg: {
              1903: 'Dati Incompleti o Errati',
              1904: 'Formato email non valido',
              1906: 'Password inserite non corrispondenti',
              1910: 'Errore invio email',
              1911: 'Codice PIN non valido',
              1912: 'Errore Registrazione dati',
              1917: 'Registrazione avvenuta con Successo',
              1918: 'E\' necessario prendere visione dell\'Informativa Privacy',
              1921: 'Errore reCAPTCHA',
              1998: 'Numero di filtri trovati non corretto',
              1999: 'Errore Autenticazione',
              AL05: '[LDAP] Profilo già esistente',
              confirm: 'Registrazione avvenuta con Successo'
            }
          }
        },
        en_GB: {
          register: {
            gdpr: {
              titolo: 'Información Básica sobre Protección de Datos',
              respTrattTitolo: 'Responsable del tratamiento',
              respTrattTesto: 'SIDERÚRGICA SEVILLANA S.A',
              finTrattTitolo: 'Finalidad del tratamiento',
              finTrattTesto: 'Realizar la gestión de la relación comercial entre las partes y la gestión fiscal y administrativa de nuestros proveedores.',
              legTrattTitolo: 'Legitimación del tratamiento',
              legTrattTesto: 'Relación contractual entre las partes.',
              destTitolo: 'Destinatarios',
              destTesto: 'Sus datos podrán comunicarse al resto de empresas del GRUPO RIVA para gestión empresarial que puede conllevar transferencia internacional de datos siempre en territorio de la UE.',
              doveriTitolo: 'Derechos',
              doveriTesto: 'Tiene derecho a acceder, rectificar y suprimir los datos, así como otros derechos, como se explica en la información adicional.',
              infoAddTitolo: 'Información adicional',
              infoAddTesto: 'Puede consultar la información adicional y detallada sobre Protección de Datos haciendo',
              cliccaQui: 'click aquí.',
              hoLetto: 'He leído y acepto las condiciones detalladas en la Información básica sobre protección de datos.'
            },
            title: 'Registration',
            form1: {
              title: 'Activation Data',
              codiFor: 'Supplier Code *',
              codiPin: 'PIN Code *'
            },
            form2: {
              title: 'Requested Services'
            },
            form3: {
              title: 'Personal Data *',
              name: 'First name *',
              mail: 'e-Mail *',
              tel: 'Office Phone *',
              surname: 'Surname',
              birthday: 'Date of birth',
              department: 'Department',
              role: 'Role',
              mobile: 'Mobile Phone'
            },
            form4: {
              title: 'Security',
              user: 'User *',
              password: 'Password *',
              passwordRepeat: 'Repeat Password *',
              rqsQstn: 'Secret Question *',
              ansQstn: 'Secret Answer *',
              infoPersData: 'Information on the processing of personal data',
              docPersData: 'Privacy disclaimer',
              viewed: 'Acknowledgment',
              userTooltip: 'The user name must begin with a letter and be from 6 to 16 alphanumeric characters (including # - _ @)',
              pswTooltip: 'The password must be 12 to 30 characters long and must contain at least one uppercase letter, one lowercase letter, one number and one special character between @ $ ! % * ? & # . _ -'
            },
            btn: {
              next: 'Next',
              register: 'Register'
            },
            msg: {
              1903: 'Request parameter error',
              1904: 'Invalid email format',
              1906: 'Entered passwords don\'t match',
              1910: 'Error in sending the mail',
              1911: 'Invitation not found',
              1912: 'Error Saving data on AS400',
              1917: 'User duly registered',
              1918: 'Vision Taking is required',
              1921: 'reCAPTCHA Error',
              1998: 'Number of filters found incorrect',
              1999: 'Authentication error in the service',
              AL05: 'Create Entry Error: [LDAP: error code 68 - Entry Already Exists]',
              confirm: 'User duly registered'
            }
          }
        },
        es_ES: {
          register: {
            gdpr: {
              titolo: 'Información Básica sobre Protección de Datos',
              respTrattTitolo: 'Responsable del tratamiento',
              respTrattTesto: 'SIDERÚRGICA SEVILLANA S.A',
              finTrattTitolo: 'Finalidad del tratamiento',
              finTrattTesto: 'Realizar la gestión de la relación comercial entre las partes y la gestión fiscal y administrativa de nuestros proveedores.',
              legTrattTitolo: 'Legitimación del tratamiento',
              legTrattTesto: 'Relación contractual entre las partes.',
              destTitolo: 'Destinatarios',
              destTesto: 'Sus datos podrán comunicarse al resto de empresas del GRUPO RIVA para gestión empresarial que puede conllevar transferencia internacional de datos siempre en territorio de la UE.',
              doveriTitolo: 'Derechos',
              doveriTesto: 'Tiene derecho a acceder, rectificar y suprimir los datos, así como otros derechos, como se explica en la información adicional.',
              infoAddTitolo: 'Información adicional',
              infoAddTesto: 'Puede consultar la información adicional y detallada sobre Protección de Datos haciendo',
              cliccaQui: 'click aquí.',
              hoLetto: 'He leído y acepto las condiciones detalladas en la Información básica sobre protección de datos.'
            },
            title: 'Grabación',
            form1: {
              title: 'Datos de activación',
              codiFor: 'Código de proveedor *',
              codiPin: 'Código PIN *'
            },
            form2: {
              title: 'Servicios Requeridos'
            },
            form3: {
              title: 'Datos Personales',
              name: 'Nombre *',
              surname: 'Apellido *',
              mail: 'e-Mail *',
              tel: 'Teléfono de trabajo *',
              birthday: 'Fecha de nacimiento',
              department: 'Departamento',
              role: 'Papel',
              mobile: 'Teléfono Móvil'
            },
            form4: {
              title: 'Seguridad',
              user: 'Usuario *',
              password: 'Contraseña *',
              passwordRepeat: 'Confirme contraseña *',
              rqsQstn: 'Pregunta secreta *',
              ansQstn: 'Respuesta secreta *',
              infoPersData: 'Información sobre el tratamiento de datos personales',
              docPersData: 'Política de Privacidad',
              viewed: 'Visión Tomada',
              userTooltip: 'El nombre de usuario debe comenzar con una letra y tener entre 6 y 16 caracteres alfanuméricos (incluido # - _ @)',
              pswTooltip: 'La contraseña debe tener de 12 a 30 caracteres y debe contener al menos una letra mayúscula, una letra minúscula, un número y un carácter especial entre @ $ ! % * ? & # . _ -'
            },
            btn: {
              next: 'Adelante',
              register: 'Registro'
            },
            msg: {
              1903: 'Request parameter error',
              1904: 'Formato de correo electrónico no válido',
              1906: 'Las contraseñas no coinciden',
              1910: 'Error al enviar el correo',
              1911: 'Invitación no encontrada',
              1912: 'Error al guardar datos en AS400',
              1917: 'Usuario registrado correctamente',
              1918: 'Se requiere Visión Tomada',
              1921: 'reCAPTCHA Error',
              1998: 'Cantidad de filtros encontrados incorrectos',
              1999: 'Error de autenticación en el servicio',
              AL05: 'Create Entry Error: [LDAP: error code 68 - Entry Already Exists]',
              confirm: 'Usuario registrado correctamente'
            }
          }
        },
        fr_FR: {
          register: {
            gdpr: {
              titolo: 'Información Básica sobre Protección de Datos',
              respTrattTitolo: 'Responsable del tratamiento',
              respTrattTesto: 'SIDERÚRGICA SEVILLANA S.A',
              finTrattTitolo: 'Finalidad del tratamiento',
              finTrattTesto: 'Realizar la gestión de la relación comercial entre las partes y la gestión fiscal y administrativa de nuestros proveedores.',
              legTrattTitolo: 'Legitimación del tratamiento',
              legTrattTesto: 'Relación contractual entre las partes.',
              destTitolo: 'Destinatarios',
              destTesto: 'Sus datos podrán comunicarse al resto de empresas del GRUPO RIVA para gestión empresarial que puede conllevar transferencia internacional de datos siempre en territorio de la UE.',
              doveriTitolo: 'Derechos',
              doveriTesto: 'Tiene derecho a acceder, rectificar y suprimir los datos, así como otros derechos, como se explica en la información adicional.',
              infoAddTitolo: 'Información adicional',
              infoAddTesto: 'Puede consultar la información adicional y detallada sobre Protección de Datos haciendo',
              cliccaQui: 'click aquí.',
              hoLetto: 'He leído y acepto las condiciones detalladas en la Información básica sobre protección de datos.'
            },
            title: 'Enregistrement',
            form1: {
              title: 'Données d\'activation',
              codiFor: 'Code du Fournisseur *',
              codiPin: 'Code PIN *'
            },
            form2: {
              title: 'Services Requis'
            },
            form3: {
              title: 'Données Personnelles',
              name: 'Prenom *',
              surname: 'Nom *',
              mail: 'Adresse email *',
              tel: 'Téléphone *',
              birthday: 'Date de naissance',
              department: 'Département',
              role: 'Role',
              mobile: 'Téléphone portable'
            },
            form4: {
              title: 'Sécurité',
              user: 'Utilisateur *',
              password: 'Mot de passe *',
              passwordRepeat: 'Confirmer le mot de passe *',
              rqsQstn: 'Question de sécurité *',
              ansQstn: 'Réponse secrète *',
              infoPersData: 'Informations sur le traitement des données personnelles',
              docPersData: 'Politique de protection des données',
              viewed: 'Vision prise',
              userTooltip: 'Le nom d\'utilisateur doit commencer par une lettre et comporter de 6 à 16 caractères alphanumériques (y compris # - _ @)',
              pswTooltip: 'Le mot de passe doit être composé de 12 à 30 caractères et doit contenir au moins une lettre majuscule, une lettre minuscule, un chiffre et un caractère spécial entre @ $ ! % * ? & # . _ -'
            },
            btn: {
              next: 'Avancer',
              register: 'Enregistrez-vous'
            },
            msg: {
              1903: 'Request parameter error',
              1904: 'Format de courrier électronique non valide',
              1906: 'Les mots de passe saisis ne sont pas valables',
              1910: 'Erreur lors de l\'envoi du mail',
              1911: 'Invitation introuvable',
              1912: 'Erreur lors de l\'enregistrement des données sur AS400',
              1917: 'Enregistrement de l\'utilisateur effectué',
              1918: 'Vision prise obligatoire',
              1921: 'reCAPTCHA Error',
              1998: 'Nombre de filtres trouvés incorrects',
              1999: 'Erreur d\'authentification dans le service',
              AL05: 'Create Entry Error: [LDAP: error code 68 - Entry Already Exists]',
              confirm: 'Enregistrement de l\'utilisateur effectué'
            }
          }
        },
        de_DE: {
          register: {
            gdpr: {
              titolo: 'Información Básica sobre Protección de Datos',
              respTrattTitolo: 'Responsable del tratamiento',
              respTrattTesto: 'SIDERÚRGICA SEVILLANA S.A',
              finTrattTitolo: 'Finalidad del tratamiento',
              finTrattTesto: 'Realizar la gestión de la relación comercial entre las partes y la gestión fiscal y administrativa de nuestros proveedores.',
              legTrattTitolo: 'Legitimación del tratamiento',
              legTrattTesto: 'Relación contractual entre las partes.',
              destTitolo: 'Destinatarios',
              destTesto: 'Sus datos podrán comunicarse al resto de empresas del GRUPO RIVA para gestión empresarial que puede conllevar transferencia internacional de datos siempre en territorio de la UE.',
              doveriTitolo: 'Derechos',
              doveriTesto: 'Tiene derecho a acceder, rectificar y suprimir los datos, así como otros derechos, como se explica en la información adicional.',
              infoAddTitolo: 'Información adicional',
              infoAddTesto: 'Puede consultar la información adicional y detallada sobre Protección de Datos haciendo',
              cliccaQui: 'click aquí.',
              hoLetto: 'He leído y acepto las condiciones detalladas en la Información básica sobre protección de datos.'
            },
            title: 'Registrierung',
            form1: {
              title: 'Aktivierungsdaten',
              codiFor: 'Lieferantencode *',
              codiPin: 'PIN-Code *'
            },
            form2: {
              title: 'Erforderliche Anwendungen'
            },
            form3: {
              title: 'Persönliche Daten ',
              name: 'Vorname *',
              surname: 'Nachname *',
              mail: 'Emailadresse *',
              tel: 'Telefon *',
              birthday: 'Geburtsdatum',
              department: 'Abteilung',
              role: 'Tätigkeit',
              mobile: 'Mobiltelefon'
            },
            form4: {
              title: 'Sicherheit',
              user: 'Benutzer *',
              password: 'Passwort *',
              passwordRepeat: 'Passwort bestätigen *',
              rqsQstn: 'Sicherheitsfrage *',
              ansQstn: 'Antwort auf Sicherheitsfrage *',
              infoPersData: 'Datenschutzbestimmungen',
              docPersData: 'Datenschutzerklärung',
              viewed: 'zur Kenntnis genommen',
              userTooltip: 'Der Benutzername muss mit einem Buchstaben beginnen und aus 6 bis 16 alphanumerischen Zeichen (einschließlich # - _ @) bestehen',
              pswTooltip: 'Das Passwort muss 12 bis 30 Zeichen lang sein und mindestens einen Großbuchstaben, einen Kleinbuchstaben, eine Zahl und ein Sonderzeichen dazwischen enthalten @ $ ! % * ? & # . _ -'
            },
            btn: {
              next: 'Weiter',
              register: 'Registrierung abschließen'
            },
            msg: {
              1903: 'Request parameter error',
              1904: 'Ungültiges E-Mail-Format',
              1906: 'Eingegebene Passwörter stimmen nicht',
              1910: 'Fehler beim Senden der E-Mail',
              1911: 'Einladung nicht gefunden',
              1912: 'Fehler beim Speichern von Daten auf dem AS400',
              1917: 'Benutzer korrekt registriert',
              1918: 'verpflichtende Vision übernehmen',
              1921: 'reCAPTCHA Error',
              1998: 'Anzahl der gefundenen Filter nicht korrekt',
              1999: 'Authentifizierungsfehler im Dienst',
              AL05: 'Create Entry Error: [LDAP: error code 68 - Entry Already Exists]',
              confirm: 'Benutzer korrekt registriert'
            }
          }
        }
      }
    },
    beforeMount: function () {
      this.getSecretQuestions()
    },
    methods: {
      clearValidation: function (campo) {
        this.$refs.step4Form.clearValidate(campo)
      },
      clearError: function (step) {
        if (step === 1) {
          this.validateStep1 = false
        } else if (step === 3) {
          this.validateStep3 = false
        }
        this.isErrorLogin = false
      },
      checkInvito: function () {
        this.$http.get('noauth/checkinvite', {
          params: {
            codLang: sessionStorage.getItem('codLang'),
            codForn: this.step1Form.codiceForn,
            codInvito: this.step1Form.codicePIN
          }
        })
          .then(response => {
            if (response.status === 200) {
              if (response.body.rc === 0) {
                this.$set(this, 'appsRichiedibili', response.body.data)
                this.validateStep1 = true
                this.activeName = ['b']
                this.currentActiveName = 'b'
              } else {
                this.$message({
                  showClose: true,
                  message: response.body.msg[0].msgTxt,
                  type: 'error',
                  duration: process.env.duration
                })
                this.validateStep1 = false
                this.validateStep2 = false
                this.validateStep3 = false
              }
            }
          }, response => {
            console.log(response)
          })
      },
      validateServices: function () {
        this.validateStep2 = true
        this.activeName = ['c']
        this.currentActiveName = 'c'
      },
      validateForm: function (formName, step) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if (step === 1) {
              this.checkInvito()
            } else if (step === 3) {
              this.validateStep3 = true
              this.activeName = ['d']
              this.currentActiveName = 'd'
            }
          } else {
            if (step === 1) {
              this.validateStep1 = false
            } else if (step === 3) {
              this.validateStep3 = false
            }
            return false
          }
        })
      },
      cambio: function (val) {
        this.activeName = []
        if (val === 'a') {
          this.currentActiveName = 'a'
        } else if (val === 'b' && this.validateStep1) {
          this.currentActiveName = 'b'
        } else if (val === 'c' && this.validateStep1 && this.validateStep2 && this.appsRichieste.length > 0) {
          this.currentActiveName = 'c'
        } else if (val === 'd' && this.validateStep1 && this.validateStep2 && this.validateStep3 && this.appsRichieste.length > 0) {
          this.currentActiveName = 'd'
        }
      },
      changeTab: function () {
        this.activeName = [this.currentActiveName]
      },
      markRecaptchaAsVerified (response) {
        console.log('response:' + response)
        this.step4Form.recaptchaToken = response
      },
      submitForm: function (formName) {
        this.$refs[formName].validate((valid) => {
          if (valid && this.step4Form.recaptchaToken !== '') {
            let apps = []
            this.appsRichieste.forEach((app) => {
              let obj = {
                codiApp: app
              }
              apps.push(obj)
            })
            let obj = {
              name: this.step3Form.nome,
              surname: this.step3Form.cognome,
              mail: this.step3Form.mail,
              preferredLanguage: this.language,
              phone: this.step3Form.tel,
              mobile: this.step3Form.cell,
              reparto: this.step3Form.reparto,
              mansione: this.step3Form.ruolo,
              birthday: this.step3Form.birthday,
              username: this.step4Form.user,
              password: this.step4Form.password,
              passwordRepeat: this.step4Form.passwordRep,
              rqsQstn: this.step4Form.domanda,
              ansQstn: this.step4Form.risposta,
              recaptchaToken: this.step4Form.recaptchaToken,
              codForn: this.step1Form.codiceForn,
              codInvito: this.step1Form.codicePIN,
              checkPrivacy: this.step4Form.checkPrivacy ? '1' : '0',
              apps: apps,
              appsLength: apps.length
            }
            // recaptchaToken
            this.$http.post('noauth/save', obj, {
              params: {
                codLang: sessionStorage.getItem('codLang')
              }
            })
              .then(response => {
                if (response.status === 200) {
                  if (response.body.rc === 0) {
                    this.$message({
                      showClose: true,
                      message: response.body.msg[0].idWeb ? this.$t(response.body.msg[0].idWeb) : response.body.msg[0].msgTxt,
                      type: 'success',
                      duration: process.env.duration
                    })
                    this.$router.push({name: 'Login'})
                  } else {
                    this.$message({
                      showClose: true,
                      message: response.body.msg[0].idWeb ? this.$t(response.body.msg[0].idWeb) : response.body.msg[0].msgTxt,
                      type: 'error',
                      duration: process.env.duration
                    })
                  }
                }
              }, response => {
                console.log('error login!!')
                // this.isErrorLogin = true
              })
          } else {
            console.log('error submit!!')
            // this.isErrorLogin = true
            return false
          }
        })
      },
      getSecretQuestions: function () {
        let obj = {
          params: {
            codLang: this.language
          }
        }
        this.$http.get('noauth/domandesic', obj)
          .then(response => {
            if (response.body.rc === 0) {
              this.$set(this, 'secretQuestions', response.body.data)
            } else {
              this.$set(this, 'secretQuestions', [])
              this.$message({
                showClose: true,
                message: response.body.msg[0].idWeb ? this.$t(response.body.msg[0].idWeb) : response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
          })
      }
    }
  }
</script>

<style lang="less">
  @import "../../assets/less/general.less";

  .RegistrazioneModulo {
    height: 770px;
    padding-top: 15px;
    padding-bottom: 15px;
    h1 {
      text-align: right;
      .set-font(@weight: 300,@size: 24px, @color: #fff);
      margin-bottom: 20px;
    }
    .info {
      .displayBlock {
        display: block;
      }
      span {
        .set-font(@weight: 700,@size: 12px, @color: #000);
      }
      a {
        text-align: center;
        img {
          width: 25px;
        }
        span {
          .set-font(@weight: 700,@size: 12px, @color: #666);
          text-decoration: underline;
        }
      }
    }
    .el-checkbox-group {
      .el-checkbox {
        width: 100% !important;
        .el-checkbox__label {
          .set-font(@color: @white; @size: 14px);
        }
        .el-checkbox__inner {
          background-color: @white;
          color: @greenRiva;
          border-color: @white;
          width: 20px;
          height: 20px;
        }
        .el-checkbox__inner {
          background-color: @white;
          color: @greenRiva;
          border-color: @white;
          width: 20px;
          height: 20px;
        }
        .is-checked {
          .el-checkbox__inner::after {
            border: 1px solid @greenRiva;
            border-left: 0;
            border-top: 0;
            height: 11px;
            width: 5px;
            left: 5px;
          }
        }
      }
      .el-checkbox + .el-checkbox {
        margin-left: 0px;
      }
    }
    .el-button {
      .set-font(@weight: 300,@size: 14px, @color: #fff);
      background-color: #000;
      background-color: rgba(0, 0, 0, .6);
      font-weight: 300;
      transition: background-color .3s;
      border: 0;
      border-radius: 0;
      width: 100%;
      text-align: center;
      margin-top: 30px;
      &:hover {
        background-color: #000;
        background-color: rgba(0, 0, 0, .8);
        // cursor: pointer;
      }
      &:focus {
        outline: 0
      }
    }
    .box-riempimento {
      height: 190px;
    }
    #form4 {
      .el-form-item__content {
        margin-bottom: 4px;
      }
    }
    .el-form-item {
      //text-align: left;
      margin-bottom: 0;
      .help {
        height: 30px;
        line-height: 25px;
        text-align: center;
        .fa-icon {
          color: @white;
        }
      }
      &.form-username {
        margin-top: 1px;
        .el-form-item__error {
          top: 1px;
          right: 15%;
          left: inherit;
          font-size: 22px;
        }
      }
      &.form-password {
        margin-top: 1px;
        .el-form-item__error {
          top: 1px;
          right: 15%;
          left: inherit;
          font-size: 22px;
        }
      }
      .el-form-item__error {
        display: none;
      }
      &.form-username {
        .el-form-item__error {
          display: inline !important;
        }
      }
      &.form-password {
        .el-form-item__error {
          display: inline !important;
        }
      }
      .el-form-item__content {
        line-height: 35px;
        .el-select {
          width: 100%;
        }
      }
      &.is-error {
        .el-input__inner {
          outline: #f56c6c solid 1px;
          outline: rgba(255, 0, 0, 0.9) solid 1px;
          outline-offset: 0px;
        }
      }
      .el-input {
        width: 100%;
        .el-input__inner {
          .set-font(@weight: 300,@size: 14px, @color: #000);
          display: block;
          //margin: 10px auto;
          padding: 10px;
          width: 100%;
          border: 0;
          background-color: #fff;
          //background-color: rgba(255, 255, 255, .7);
          border: none;
          border-radius: 0px;
          line-height: 0;
          height: 30px;
          &:focus {
            outline: #000 solid 1px;
            outline: rgba(0, 0, 0, .4) solid 1px;
            outline-offset: 0px;
          }
        }
        .el-input__prefix {
          display: none;
        }
        ::placeholder {
          color: #a2a2a2;
          font-style: italic;
        }
      }
      .el-checkbox__label {
        color: #000;
      }
    }
    .errorLogin {
      .set-font(@weight: 300, @size: 14px, @color: #d20e0e);
      //display: block;
      height: 22px;
      text-align: center;
    }

    .gdpr-spagna {
      border-left: 1px solid @white;
      height: 436px;
      margin-top: 162px;
      padding-left: 15px !important;
      .contenitore-gdpr {
        width: 100%;
        height: 100%;
        background-color: @white;
        padding-top: 5px;
        .titolo {
          .set-font(@color: @greenRiva, @size: 12px, @family: 'os-semibold');
          margin-bottom: 10px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .box {
          height: 403px;
          overflow-y: auto;
          .subtitolo {
            .set-font(@color: @greenRiva, @size: 10px, @family: 'os-semibold');
            margin-top: 10px;
            font-style: italic;
          }
          .testo {
            .set-font(@color: @textTable, @size: 10px);
            a {
              color: @greenRiva;
              text-decoration: underline;
            }
            a:hover {
              .set-font(@color: @greenRiva, @size: 10px, @family: 'os-semibold');
            }
            a:visited {
              color: @greenRiva;
            }
          }
        }
        .check-privacy {
          .el-checkbox {
            width: 100% !important;
            margin-top: 15px;
            white-space: normal;
            padding-left: 15px;
            .el-checkbox__input {
              position: absolute;
              top: 3px;
              .el-checkbox__inner {
                border-radius: 0px;
              }
              .el-checkbox__inner:hover {
                border-color: @greenRiva;
              }
              &.is-checked {
                .el-checkbox__inner {
                  background-color: @greenRiva;
                  border-color: @greenRiva;
                }
              }
            }
            .el-checkbox__label {
              width: 91%;
              padding-left: 22px;
              .text-checkbox {
                .set-font(@color: @textTable, @size: 10px);
              }
            }
          }
        }
      }
    }

    // Accordion
    .el-collapse {
      // width: 350px;
      // text-align: center;
      // margin-right: auto;
      // margin-left: auto;
      border: none;
      div[role=tab] {
        height: 30px;
        margin-top: 6px;
        margin-bottom: 6px;
        div[role=button] {
          border: none;
          background-color: transparent;
          line-height: 24px;
          i {
            display: none;
          }
          .icon {
            float: left;
            background-color: #fff;
            width: 30px;
            height: 30px;
            border-radius: 50%;
            border: 2px solid;
            border-color: inherit;
            span {
              .set-font(@weight: 300,@size: 20px, @color: #000);
              padding-left: 7px;
            }
            .fa-icon {
              margin-top: 5px;
              margin-left: 0px;
            }
            &.is-correct {
              background-color: #000;
            }
          }
          .des {
            .set-font(@weight: 300,@size: 18px, @color: #fff);
            padding-left: 12px;
            padding-top: 1px;
          }
        }
      }
      div[role=tabpanel] {
        border: none;
        background-color: transparent;
        border-left: 1px solid #fff;
        margin-left: 12px;
        margin-bottom: 6px;
        margin-top: 16px;
        padding-left: 30px;
        padding-right: 5px;
      }
    }
    .el-select {
      .el-input__suffix {
        top: -3px;
        .el-input__suffix-inner {
          position: absolute;
          right: 0px;
        }
      }
    }
    .riv-tick-c0 {
      fill: #fff;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Login/Registrazione.vue